import styled from 'styled-components';

export const GlobalContainerDashboard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;
